export const PAGE_WIDTH = 210;
export const PAGE_HEIGHT = 295;

export const GREEN_RGB = [46, 184, 92];
export const BLACK_RGB = [0, 0, 0];
export const WHITE_RGB = [255, 255, 255];
export const GOLD_RGB = [249, 177, 21];
export const CREAM_RGB = [253, 245, 232];